<template>
<navBack></navBack>  
  <div class="page">
    <customer-bar :customer="customer"></customer-bar>

    <div class="section">
      <t-cell title="卡项" v-if="cardInfo._id" :description="cardInfo.cardName" arrow hover @click="showCardDialog = true"
        :note="cardInfo.type == 6 ? `${cardInfo.product?.name}*${cardInfo.cardCount}次` : `${cardInfo.discount}折`">
      </t-cell>
      <t-cell v-else title="卡项" arrow hover @click="showCardDialog = true" note="选择">
      </t-cell>

      <t-cell title="类型" :note="cardInfo.type == 6 ? '次卡' : '打折卡'">
      </t-cell>

      <t-cell title="有效期" :note="expireDate == 0 ? '永久有效' : getExpireDateLabel(expireDate)" arrow
        @click="showExpireDateSheet = true">
      </t-cell>

      <t-input label="收款金额" type="number" @change="doChangeRechargeAmount" align="right" v-model="totalPrice"
        placeholder="请录入收款金额" suffix="元">
      </t-input>
    </div>

    <div class="section">
      <t-cell title="业务员" hover arrow :note="seller.name || '请选择'" @click="showServiceDialog = true">
      </t-cell>

      <t-cell title="付款方式" hover arrow @click="showPayTypeSheet = true" :note="payType.label || '请选择'">
      </t-cell>
    </div>
  </div>

  <div class="confirmBar">
    <t-button    size="large" :disabled="isLoading" theme="primary" @click="doSubmitOrder">
      结算
      <span v-if="totalPrice">¥ {{ totalPrice }}</span>
    </t-button>
  </div>

  <t-popup v-model:visible="showCardDialog" placement="bottom" destroy-on-close>
    <choseCard @closeDialog="showCardDialog = false" @choseCard="confirmCard">
    </choseCard>
  </t-popup>

  <t-popup v-model:visible="showServiceDialog" placement="bottom" destroy-on-close>
    <choseServiceLite :order-type="type" @closeDialog="showServiceDialog = false" @confirm="confirmService">
    </choseServiceLite>
  </t-popup>

  <t-action-sheet v-model:visible="showPayTypeSheet" :items="payTypeSheetItems" @selected="handlePayTypeSelected"
    @cancel="handleCancel" />

  <t-action-sheet v-model:visible="showExpireDateSheet" :items="expireDateItems" @selected="handleExpireDateSelected"
    @cancel="handleCancel" />
</template>

<script setup>
import { ref, onMounted, reactive, getCurrentInstance } from 'vue'
import { stateCustomer, stateShop, stateUser,stateReloadCustomer } from '@/store'
import customerBar from '@/components/customer-bar.vue'
import choseServiceLite from '@/components/chose-service-lite.vue'
import choseCard from '@/components/chose-card.vue'
import Decimal from 'decimal'
import { Toast } from 'tdesign-mobile-vue'
import { getTimeBag, formatTimeSN } from '@/utils.js'
import navBack  from '@/components/nav-back-top.vue'
const { proxy } = getCurrentInstance()
const app = proxy.$cloudbase

// 响应式数据
const customer = reactive({})
const cardInfo = reactive({})
const commission = reactive({})
const seller = reactive({})
const type = ref(2)

const showPayTypeSheet = ref(false)
const showServiceDialog = ref(false)
const showExpireDateSheet = ref(false)
const showCardDialog = ref(false)

const payTypeSheetItems = ref([
  { label: '微信', value: 'wepay' },
  { label: '支付宝', value: 'alipay' },
  { label: '现金', value: 'cash' }
])

const expireDateItems = ref([
  { label: '永久有效', value: 0 },
  { label: '1年', value: 365 },
  { label: '6个月', value: 180 },
  { label: '3个月', value: 90 },
  { label: '1个月', value: 30 }
])

const expireDate = ref(0)
const totalPrice = ref('')
const payType = reactive({})
const isLoading = ref(false)

// 工具方法
const getExpireDateLabel = (value) => {
  const item = expireDateItems.value.find(item => item.value === value)
  return item ? item.label : `${value}天`
}


// 事件处理方法
const handleExpireDateSelected = (item) => {
  expireDate.value = item.value
  showExpireDateSheet.value = false
}

const handlePayTypeSelected = (item) => {
  Object.assign(payType, item)
  console.log('选择付款方式', item)
  showPayTypeSheet.value = false
}

const handleCancel = () => {
  showPayTypeSheet.value = false
  showExpireDateSheet.value = false
}

const confirmService = (result) => {
  Object.assign(seller, result.seller)
  Object.assign(commission, result.commission)
  showServiceDialog.value = false
}

const confirmCard = (card) => {
  console.log('确认卡项', card)
  Object.assign(cardInfo, card)
  totalPrice.value = card.totalPrice || ''
  expireDate.value = card.expireDate || 0
  type.value = card.type || 2
  showCardDialog.value = false
}

const doChangeRechargeAmount = (value) => {
  totalPrice.value = value
  console.log('收款金额变更:', value)
}

// 业务逻辑方法
const getOrderNo = async () => {
  try {
    const db = app.database()
    const timeBag = getTimeBag()

    const orderCountRes = await db.collection("my_order").where({
      "createAt.time3": timeBag.time3,
      shopId: stateShop._id
    }).count()

    const orderCount = orderCountRes.total
    let orderNo = formatTimeSN() * 10000 + orderCount + 1
    return "XS" + orderNo
  } catch (error) {
    console.error('获取订单号失败:', error)
    throw error
  }
}

const calculateTiCheng = () => {
  let tichengAmount = 0
  if (commission._id) {
    tichengAmount = new Decimal(totalPrice.value || 0).mul(commission.commissionValue || 0).toNumber()
  }

  return {
    totalTiChengAmount: tichengAmount,
    tichengSummary: [{
      productType: type.value == 6 ? 2 : 3,
      _id: type.value == 6 ? 'cika' : 'discount',
      productName: type.value == 6 ? '次卡' : '打折卡',
      categoryId: '',
      realPay: new Decimal(totalPrice.value || 0).mul(100).toNumber(),
      shl: 1,
      payWay: payType.value,
      ticheng: seller._id ? [{
        tichengAmount,
        commission,
        role: seller.role,
        _id: seller._id,
        name: seller.name,
        yejiAmount: new Decimal(totalPrice.value || 0).mul(100).toNumber(),
      }] : []
    }]
  }
}

const doSubmitOrder = () => {
  if (type.value == 6) {
    submitCika()
  } else {
    submitDiscountCard()
  }
}

const validateOrder = () => {
  if (!customer._id) {
    Toast({ message: '请选择客户', theme: 'error' })
    return false
  }

  if (!cardInfo._id) {

    Toast({ message: '请选择卡项', theme: 'error' })
    return false
  }

  if (!payType.value) {
    Toast({ message: '请选择支付方式', theme: 'error' })

    return false
  }

  if (!totalPrice.value) {

    Toast({ message: '请输入收款金额', theme: 'error' })

    return false
  }

  return true
}

const submitDiscountCard = async () => {
  if (!validateOrder()) return

  try {
    isLoading.value = true

    const orderNo = await getOrderNo()
    const _totalPrice = new Decimal(totalPrice.value).mul(100).toNumber()
    payType.amount = _totalPrice
    const tichengBag = calculateTiCheng()

    const _data = {
      orderNo,
      customer,
      cardId: cardInfo._id,
      status: 1,
      type: 3,
      seller,
      discount: Number(cardInfo.discount) * 10,
      cardName: cardInfo.cardName,
      ...tichengBag,
      totalPrice: _totalPrice,
      realPay: _totalPrice,
      totalPay: _totalPrice,
      sumPrice: _totalPrice,
      expireDate: expireDate.value,
      createAt: getTimeBag(),
      backColorIndex: 0,
      payType: [payType],
      operator: stateUser,
      payWay: payType.value,
      shopId: stateShop._id,
    }

    await app.callFunction({
      name: 'my_confirm_order',
      data: {
        op: 'discount',
        ..._data
      }
    })
    stateReloadCustomer.value = true
    Toast.success('办卡成功')
  } catch (err) {
    console.error('办卡失败:', err)


    Toast({ message: '操作失败', theme: 'error' })

  } finally {
    isLoading.value = false
  }
}

const submitCika = async () => {
  if (!validateOrder()) return

  try {
    isLoading.value = true

    const _totalPrice = new Decimal(totalPrice.value).mul(100).toNumber()
    payType.amount = _totalPrice
    const tichengBag = calculateTiCheng()
    const orderNo = await getOrderNo()

    const _data = {
      orderNo,
      customer,
      status: 1,
      cardId: cardInfo._id,
      type: 2,
      seller,
      product: cardInfo.product,
      cardName: cardInfo.cardName,
      cardCount: Number(cardInfo.cardCount),
      totalCount: Number(cardInfo.cardCount),
      totalPrice: _totalPrice,
      realPay: _totalPrice,
      totalPay: _totalPrice,
      sumPrice: _totalPrice,
      expireDate: Number(expireDate.value),
      ...tichengBag,
      createAt: getTimeBag(),
      operator: stateUser,
      payType: [payType],
      payWay: payType.value,
      backColorIndex: 0,
      shopId: stateShop._id,
    }

    await app.callFunction({
      name: 'my_confirm_order',
      data: {
        op: 'cika',
        ..._data
      }
    })

    Toast.success('充次成功')
  } catch (err) {


    Toast({ message: '操作失败', theme: 'error' })
  } finally {
    isLoading.value = false
  }
}

// 生命周期
onMounted(() => {
  Object.assign(customer, stateCustomer)
  console.log('stateCustomer', stateCustomer)
})
</script>

<style scoped>
.page {
 
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 15vh;
}

.section {
  background-color: #fff;
  margin-bottom: 20px;
  padding: 0 20px;
}

.confirmBar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20vw;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 -1px 34px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

 
</style>